import { get, post } from 'axios'

const URL = '/survey'

export const getSurvey = async () =>
  (await get(`${URL}?_=${new Date().getTime()}`)).data

export const postSurvey = data => post(`${URL}`, data)
